import './rangeSlider.scss';
import "react-range-slider-input/dist/style.css";
import { useState } from 'react';
import { default as RS } from 'react-range-slider-input';

interface IRangeSliderProps {
	id?: string | null;
	className?: string | null;
	min: number;
	max: number;
	step?: number;
	defaultValue?: number[];
	value: number[];
	onInput?: (data: number[]) => void;
	onThumbDragStart?: () => void;
	onThumbDragEnd?: () => void;
	onRangeDragStart?: () => void;
	onRangeDragEnd?: () => void;
	disabled?: boolean;
	rangeSlideDisabled?: boolean;
	thumbsDisabled?: boolean[] | boolean;
	orientation?: string;
}
const RangeSlider = (props: IRangeSliderProps) => {
	const [thumbDragState, setThumbDragState] = useState(false);
	return (
		<RS 
			{...props}
			onInput={(data) => {
				if (data[0] === data[1]) {
					setThumbDragState(true);
				}
				if (props.onInput) props.onInput(data);
			}}
			thumbsDisabled={thumbDragState}
			onThumbDragEnd={() => {
				setThumbDragState(false);
				if (props.onThumbDragEnd) props.onThumbDragEnd();
			}}
		/>
	);
};

export default RangeSlider;